import axiosServices from "../utils/axios";

export const addPortCallNotification= async (data:  { agentOnly: boolean; hqOnly: boolean; email_introduction: string; pcid: string, attachmentList:any, includeCC:boolean}) => {
  const response = await axiosServices.post(`/reports/portcallnotification`, data);
  return (response);
};

export const getPortCallNotification = async (params: { agentOnly: boolean; pcid: string; hqOnly: boolean; showCompletedBerth: boolean }) => {
  const { agentOnly, pcid, hqOnly, showCompletedBerth } = params;
  let url=`/reports/portcallnotification?agentOnly=${agentOnly}&pcid=${pcid}&hqOnly=${hqOnly}`;
  if(showCompletedBerth){
    url+=`&showCompletedBerth=${showCompletedBerth}`;
  }
  const response = await axiosServices.get(`${url}`);
  return response;
};